import { getNavigablePagesMetadata } from '../pages';
import { beginsWith } from './string';

export const RoleDefinitions = {
    Admin: { type: 'gl-admin', label: 'Superuser' },
    AdminFinance: { type: 'gl-finance', label: 'Provider Finance' },
    AdminHumanResources: { type: 'gl-hr', label: 'Provider Success Rep' },
    Client: { type: 'cl-admin', label: 'Client Administrator' },
    ClientTimesheetApprover: { type: 'cl-ts', label: 'Timesheet Approver' },
    ClientHiringManager: { type: 'cl-hm', label: 'Hiring Manager' },
    ClientAPI: { type: 'cl-api', label: 'Client-scoped API User' },
    Contractor: { type: 'contractor', label: 'Worker' },
    Witness: { type: 'witness', label: 'I9 Signer' }
};

export const RoleSubsets = {
    ContractorIC: { type: 'contractorIC', label: 'Independent Contractor' },
    ContractorW2: { type: 'contractorW2', label: 'Contract Employee' }
};

export function isAdmin(role) {
    if (!role || !role.role) {
        return false;
    }

    return [RoleDefinitions.Admin, RoleDefinitions.AdminFinance, RoleDefinitions.AdminHumanResources].find(r => r.type === role.role) !== undefined;
}

export function isEligibleTenant(role, eligibleTenants, navigablePages, pathname) {
    // if no eligible tenants were specified, consider it as free-for-all.
    if (!eligibleTenants) {
        return true;
    }

    if (!role || !role.role) {
        return false;
    }

    let tenants = Array.isArray(eligibleTenants) ? eligibleTenants : [eligibleTenants];
    let isEligibleTenant = tenants.filter(t => t.type === role.role).length > 0;

    if (!isEligibleTenant) {
        return false;
    }

    let pass =
        navigablePages.find(p => p.locations && p.locations.find(l => l === pathname || (p.hide === true && beginsWith(pathname, l))) !== undefined) !==
        undefined;

    return pass;
}

export function getPagesForTenant(tenant) {
    const { role } = tenant;

    const {
        address,
        addresses,
        approval,
        approvals,
        blank,
        client,
        clients,
        company,
        dashboard,
        documents,
        onboarding,
        positions,
        position,
        settings,
        user,
        users,
        worker,
        paystubs,
        timekeeping,
        invoices,
        invoice,
        projects,
        paydue,
        payrolls
    } = getNavigablePagesMetadata();

    let eligiblePages = [];

    switch (role) {
        case RoleDefinitions.Admin.type:
            eligiblePages = [
                dashboard,
                approval,
                approvals,
                documents,
                client,
                clients,
                paydue,
                timekeeping,
                invoices,
                invoice,
                payrolls,
                users,
                user,
                settings,
                worker,
                onboarding
            ];
            break;

        case RoleDefinitions.AdminHumanResources.type:
            eligiblePages = [dashboard, approvals, clients, client, settings, worker, onboarding];
            break;

        case RoleDefinitions.Client.type:
            eligiblePages = [
                dashboard,
                positions,
                position,
                projects,
                timekeeping,
                // invoices,
                // invoice,
                company,
                address,
                addresses,
                documents,
                users,
                user,
                settings,
                worker,
                onboarding
            ];
            break;

        case RoleDefinitions.ClientHiringManager.type:
            eligiblePages = [dashboard, positions, position, timekeeping, worker, onboarding];
            break;

        case RoleDefinitions.ClientTimesheetApprover.type:
            eligiblePages = [dashboard, timekeeping, worker, onboarding];
            break;

        case RoleDefinitions.Contractor.type:
            eligiblePages = [dashboard, timekeeping, documents, paystubs, paydue, onboarding];
            break;

        case RoleDefinitions.Witness.type:
            eligiblePages = [onboarding];
            break;

        default:
            break;
    }

    return [...eligiblePages, blank, { blank: true }];
}



// WEBPACK FOOTER //
// ./src/utilities/roles.jsx